import React from 'react'
import Button from '@Components/Buttons/Button'
import { SearchResultPartyDetails } from '@Entities/party-details'

interface MergeSummaryStepProps {
    primaryWriter: SearchResultPartyDetails
    writersToMerge: SearchResultPartyDetails[]
    onBack(): void
    onSubmit(): void
}

const MergeSummaryStep = (props: MergeSummaryStepProps) => {
    const { primaryWriter, writersToMerge, onBack, onSubmit } = props

    return (
        <>
            <div className="review-information">
                <div>
                    <p>Primary Songwriter name:</p>
                    <p>
                        <b>{primaryWriter.name}</b>
                    </p>
                </div>
                <div>
                    <p>Suggested names to merge into primary name:</p>
                    <p>
                        <b>{writersToMerge.map((writer) => writer.name).join(', ')}</b>
                    </p>
                </div>
            </div>
            <div className="footer-buttons">
                <Button mainColor type="secondary" onClick={onBack}>
                    Back
                </Button>
                <Button mainColor type="primary" onClick={onSubmit}>
                    Submit
                </Button>
            </div>
        </>
    )
}
export default MergeSummaryStep
